import React from "react";
import PropTypes from 'prop-types';
import PlaylistItem from "./PlaylistItem";
import Sidebar, {Header} from "Components/Sidebar";
import BackLink from "Components/BackLink/BackLink";
import Heading from "UI/Heading";

export default class Playlist extends React.Component {
    static propTypes = {
        project: PropTypes.object.isRequired,
        stories: PropTypes.array.isRequired,

        pointer: PropTypes.string,
    }

    static defaultProps = {
        pointer: null
    };

    render() {
        const header = <Header>
            <div>
                <BackLink to={`/projects`}/>
            </div>
            <div className='p-4 pt-0 mb-4'>
                <Heading title={this.props.project.name} description={this.props.project.description}/>
            </div>
        </Header>;

        return <Sidebar header={header}>
            <div className='flex flex-col'>
                {
                    this.props.stories.map(
                        story => <PlaylistItem
                            key={story.id}
                            projectId={this.props.project.id}
                            story={story}
                            active={story.id === this.props.pointer}
                        />
                    )
                }
            </div>
        </Sidebar>;
    }
}
